import { render, staticRenderFns } from "./imageUrlupload.vue?vue&type=template&id=64156ba2&scoped=true&"
import script from "./imageUrlupload.vue?vue&type=script&lang=js&"
export * from "./imageUrlupload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64156ba2",
  null
  
)

export default component.exports